import type { TFunction } from "i18next";
import { formatDateTime } from "../../../lib/datetime/displayDateTime";

import Chip from "@mui/material/Chip";
import { optionLabel } from "../../../lib/i18n/optionLabel";

export const getProfileSourceSystemCols = (t: TFunction) => [
  {
    name: t("sourceSystems.cols.name"),
    selector: (row: { name?: string }) => row.name,
    sortable: true,
  },
  {
    name: t("sourceSystems.cols.status"),
    selector: (row: { status?: string }) => row.status,
    sortable: true,
    cell: (row: { status?: string }) => (
      <Chip
        label={optionLabel(t, "options.entityStatus", row.status)}
        size="small"
        color={row.status === "ACTIVE" ? "success" : "error"}
      />
    ),
  },
  {
    name: t("sourceSystems.cols.contacts"),
    selector: (row: { contacts?: unknown[] }) => row.contacts?.length || 0,
    sortable: true,
  },
  {
    name: t("sourceSystems.cols.sources"),
    selector: (row: { sources?: unknown[] }) => row.sources?.length || 0,
    sortable: true,
  },
  {
    name: t("sourceSystems.cols.createdDate"),
    selector: (row: { createdDate?: string }) =>
      row.createdDate ? formatDateTime(row.createdDate) : "",
    sortable: true,
  },
];

const ProfileSourceSystemModel = {
  get cols() {
    return getProfileSourceSystemCols(((key: string) => key) as TFunction);
  },
  createDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.create"),
    cancelButtonText: t("common.cancel"),
    title: t("profiles.createSourceTitle"),
    content: t("profiles.createSourceContent"),
  }),
  editDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.update"),
    cancelButtonText: t("common.cancel"),
    title: t("profiles.editSourceTitle"),
    content: t("profiles.editSourceContent"),
  }),
};

export default ProfileSourceSystemModel;
